import axios from 'axios';
import { baseURL } from '../baseURL';
import Cookies from 'js-cookie';

export async function addMistakeOrder(addOrder) {
    const { data } = await axios.post(
        `${baseURL}alibaba/mistake-order-page`,
        addOrder,
        {
            headers: {
                Authorization: `Bearer ${Cookies.get('token')}`,
            },
        }
    );
    return data;
}
